module.exports = __webpack_public_path__ + "img/logo_11.6a5a4cef.png";